import axios from "axios";
import iview from "view-design";
import _ from "lodash";
// import HeaderSign from 'bt-sign-header' // 网关修改
import { httpAxios } from "@/views/home/serve/header";

if (process.env.VUE_APP_LOCAL_ENV === "true") {
  window.env = process.env;
}

// web-gateway 网关
export const _api_carcloud = axios.create({
  baseURL: window.env.VUE_APP_BASE_API,
  // baseURL: window.env.VUE_APP_BASE_MOBILE // 网关修改
  headers: {
    "serve-name": window.env.VUE_APP_BASE_MOBILE,
  },
});

_api_carcloud.interceptors.request.use(reqSuccess, reqError);
_api_carcloud.interceptors.response.use(resSuccess, resError);

function reqSuccess(config) {
  // IEget缓存解决
  config.headers["If-Modified-Since"] = ["0"];
  config.headers.token = sessionStorage.getItem("dashboard-token") || "";
  config.headers.roleId = config.headers["roleId"] || sessionStorage.getItem("PRIVATE_USER_ROLEID") || "";
  config.headers.systemFlag = 9;
  config.headers.username =
    config.headers["username"] || sessionStorage.getItem("userName") || "";
  config.headers.operator = config.headers.username
  config.headers.brandId =
    config.headers["brandId"] || sessionStorage.getItem("PRIVATE_USER_BRANDID");
  config.headers.enterpriseId =
    config.headers["enterpriseId"] ||
    sessionStorage.getItem("PRIVATE_USER_ENTERPRISEID");
  config.headers.operatorRole = config.headers["operatorRole"] || "OFFICIAL";

  config.headers['Accept'] = 'application/json'
  config.headers['Content-Type'] = config.headers['Content-Type']  || 'application/json;charset=UTF-8'

  // const hearderSign = new HeaderSign(window.env.VUE_APP_APPKEY, window.env.VUE_APP_SECRETKEY).mobile(config) // 网关修改

  config.headers = {
    ...config.headers,
    systemDomain: document.domain,
    ...(JSON.parse(sessionStorage.routerMate || "{}")),
    // ...hearderSign, // 网关修改
  };
  return config;
}

function reqError(error) {
  console.log(error, "errorerrorerror");
  return Promise.reject(error);
}

function resSuccess(response) {
  const token = response.headers.token;
  const code = _.get(response, "data.code");
  const content = _.get(response, "data.description");

  if (token) {
    sessionStorage.setItem("dashboard-token", token);
  }
  // 629053:TOKEN已失效
  if (code !== "000000" && code != null) {
    iview.Message.error({
      content,
      duration: 3,
    });
  }
  return response;
}

function resError(error) {
  const description = _.get(error, "response.data.description");
  const status = _.get(error, "error.response.status");
  if (status === 401) {
    iview.Message.error("TOKEN已失效");
    setTimeout(function () {
      httpAxios();
    }, 1000);
  } else if (description) {
    iview.Message.error(description);
  } else if (String(status)[0] === "5") {
    iview.Message.error("服务器内部错误");
  }
  return Promise.reject(error);
}
